import { IMAGES } from "../lib/funnelData";
import { PrivacyBody, TermsBody } from "./Legal";

const LegalShell = ({ title, testid, children }) => (
  <div className="min-h-screen bg-canvas font-sans" data-testid={testid}>
    <header className="border-b border-emeraldx-deep/10">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between">
        <a href="/" data-testid={`${testid}-home-link`}>
          <img src={IMAGES.logoPlaque} alt="Cann Realty LLC" className="h-9 w-auto" />
        </a>
        <a href="/" data-testid={`${testid}-back-link`} className="text-[11px] font-semibold uppercase tracking-[0.2em] text-emeraldx-deep hover:text-oak transition-colors duration-150">
          Back to site
        </a>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <h1 className="text-3xl sm:text-4xl font-serif text-emeraldx-deep">{title}</h1>
      <span className="rule-gold mt-5" />
      <div className="mt-8">{children}</div>
    </main>
    <footer className="border-t border-emeraldx-deep/10 py-6 text-center text-xs text-stone-400">
      © {new Date().getFullYear()} Cann Realty LLC · Anderson, South Carolina
    </footer>
  </div>
);

export const PrivacyPage = () => (
  <LegalShell title="Privacy Policy" testid="privacy-page">
    <PrivacyBody />
  </LegalShell>
);

export const TermsPage = () => (
  <LegalShell title="Terms of Service" testid="terms-page">
    <TermsBody />
  </LegalShell>
);
